import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-preview-coupon',
  templateUrl: './preview-coupon.component.html',
  styleUrls: ['./preview-coupon.component.scss']
})
export class PreviewCouponComponent implements OnInit {

  @Input() module: string; // (CPG/RETAILER/SHARED)
  @Input() page: string; // Page where component is  used
  @Input() couponPreviewData: any; // Coupon data for preview

  constructor() { }

  ngOnInit(): void {
  }

}
